export const GALLERY_QUERY = 'viewType';
export enum GALLERY_QUERY_VALUE {
  HighlightDetail = 'gallery-highlight',
  PlanDetail = 'gallery-plan',
  PlanRoomCard = 'gallery-card',
  ReviewCard = 'gallery-review',
  RoomDetail = 'gallery-room',
  Slider = 'gallery-slider',
  Thumbnail = 'gallery',
  ThumbnailDetail = 'gallery-thumbnail',
}
export const GALLERY_INDEX_QUERY = 'imageIndex';
